<h2 mat-dialog-title>Import vehicles</h2>
<mat-dialog-content>
	@if (cartegraphEnabled) {
		<app-import-vehicles-cartegraph #importVehiclesCartegraphComponent/>
	} @else {
		<app-import-vehicles #importVehiclesComponent/>
	}

	@if (isWorking) {
		<mat-progress-bar mode="indeterminate"></mat-progress-bar>
	}
</mat-dialog-content>

<mat-dialog-actions class="gap-8">
	<button mat-stroked-button mat-dialog-close [disabled]="isWorking">Cancel</button>
	<button (click)="performSave()" [disabled]="!isSaveButtonEnabled()"
			color="primary"
			mat-flat-button
			type="submit">
		Import Vehicles
	</button>
</mat-dialog-actions>
